export default __webpack_public_path__ + "static/media/practice-with-friends.e5855141.svg";